import { AppContextValue } from "@/lib/context/app-context";

export const umamiTrackEvent = (event: string, appContext: AppContextValue, data?: Record<string, any>) => {
  if (window.umami) {
    const eventData = {
      ...data,
      user_id: appContext.user?.id,
      sales_channels: Array.isArray(appContext.salesChannels) ? appContext.salesChannels?.map(s => s.id).toString() : "",
      sales_channels_name: Array.isArray(appContext.salesChannels) ? appContext.salesChannels?.map(s => s.name).toString() : "",
      affx: appContext.affx
    };
    window.umami.track(event, eventData);
  }
};